import { z } from "zod";
import { email } from "~www/types/forms/schemas/email";
import { firstName } from "~www/types/forms/schemas/first-name";
import { lastName } from "~www/types/forms/schemas/last-name";
import { phone } from "~www/types/forms/schemas/phone";

/**
 * API response from `postServiceInquiry` (mirrors the care seeker shape; kept local for encapsulation).
 */
export type CarePlusInquiryResponse = {
  isError: boolean;
  errors: { code: string; reason: string; detail: string; source: string }[];
  message: string;
  id?: string;
};

export const careForEnum = z.enum(["parent", "spouse", "me", "other"]);

export type CareForValue = z.infer<typeof careForEnum>;

/**
 * RHF + client: only user-entered fields.
 */
export const carePlusInquiryFormSchema = z.object({
  careFor: careForEnum,
  email,
  firstName,
  lastName,
  phone,
});

export type CarePlusInquiryFormData = z.infer<typeof carePlusInquiryFormSchema>;

export function getCarePlusInquiryDefaultFormValues() {
  return {
    careFor: "parent" as CareForValue,
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
  };
}

/** Shallow fields from FormData for the five user fields (server or tests). */
export function parseCarePlusInquiryFormData(
  formData: FormData,
): Record<string, unknown> {
  return {
    careFor: formData.get("careFor"),
    email: formData.get("email"),
    firstName: formData.get("firstName"),
    lastName: formData.get("lastName"),
    phone: formData.get("phone"),
  };
}
